import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ParentSession {
  readonly parentId: string;
  readonly email: string;
  readonly token: string;
}

interface ParentStore {
  readonly session: ParentSession | null;
  setSession(session: ParentSession | null): void;
}

export const useParentStore = create<ParentStore>()(
  persist(
    (set) => ({
      session: null,
      setSession(session) {
        set({ session });
      },
    }),
    { name: 's4k:parent' },
  ),
);
